var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDonutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1200_19012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 2.05007V5.07007C7.608 5.55707 5 8.47507 5 12.0001C5 15.8661 8.134 19.0001 12 19.0001C13.572 19.0001 15.024 18.4821 16.192 17.6061L18.329 19.7431C16.605 21.1531 14.4 22.0001 12 22.0001C6.477 22.0001 2 17.5231 2 12.0001C2 6.81507 5.947 2.55107 11 2.05007ZM21.95 13.0001C21.75 15.0111 20.956 16.8471 19.743 18.3281L17.606 16.1921C18.293 15.2761 18.759 14.1861 18.929 13.0001H21.951H21.95ZM13.002 2.05007C17.726 2.51907 21.482 6.27607 21.952 11.0001H18.93C18.492 7.93507 16.067 5.51007 13.002 5.07107V2.04907V2.05007Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1200_19012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonutIcon);
export default __webpack_public_path__ + "static/media/DonutIcon.f135e472efe2b4c472b20c8d4368c5d6.svg";
export { ForwardRef as ReactComponent };